import { Navigate, Outlet } from 'react-router-dom';
import { APP_PATHS } from '@/app/routes/paths';
import { useCanAccessPayments } from '@/features/payments/usePaymentOptionAvailableOnWeb';

export default function PaymentsAvailabilityGuard() {
  const canAccessPayments = useCanAccessPayments();

  if (!canAccessPayments) {
    return <Navigate to={APP_PATHS.feed} replace />;
  }

  return <Outlet />;
}
